export default "__VITE_ASSET__DegwQ6kg__"